export default "__VITE_ASSET__BAOZYKER__"